/* Termoshome — Shopify dışında sunucu gerektirmeyen tasarım aracı. */
const CDN = 'https://cdn.jsdelivr.net/npm/three@0.164.0/';
let dependencies;
function loadThree() {
  if (!dependencies) {
    // Kapsamlı import map, temanın kendi three sürümünü değiştirmez.
    if (!document.querySelector('[data-termos-importmap]')) {
      const map = document.createElement('script');
      map.type = 'importmap';
      map.dataset.termosImportmap = '';
      map.textContent = JSON.stringify({ scopes: { [CDN]: {
        three: `${CDN}build/three.module.js`, 'three/addons/': `${CDN}examples/jsm/`
      } } });
      document.head.append(map);
    }
    dependencies = Promise.all([
      import(`${CDN}build/three.module.js`),
      import(`${CDN}examples/jsm/loaders/GLTFLoader.js`),
      import(`${CDN}examples/jsm/controls/OrbitControls.js`),
      import(`${CDN}examples/jsm/environments/RoomEnvironment.js`)
    ]).catch(error => { dependencies = undefined; throw error; });
  }
  return dependencies;
}

export function placement(iw, ih, cw, ch, scale, x, y) {
  const fit = Math.min(cw / iw, ch / ih) * scale;
  const width = iw * fit, height = ih * fit;
  return { width, height, left: (cw - width) / 2 + x * cw, top: (ch - height) / 2 + y * ch };
}

const dialogMarkup = `
  <header class="td-header"><div><p class="td-eyebrow">TERMOSHOME / SANA ÖZEL</p><h2>Termosunu tasarla</h2></div>
  <button type="button" class="td-close" data-close aria-label="Tasarımı kapat">×</button></header>
  <div class="td-layout"><div class="td-preview"><div class="td-stage" aria-label="Termosun 3D önizlemesi"></div>
  <div class="td-loading" role="status"><span class="td-spinner"></span><span>3D model hazırlanıyor…</span></div>
  <p class="td-hint">Döndürmek için sürükle · Yakınlaştırmak için kaydır veya iki parmağını kullan</p></div>
  <div class="td-panel"><div><p class="td-product"></p><p class="td-measures"></p></div>
  <div class="td-colors" hidden><p class="td-small"><strong>Kapak rengi:</strong> <span data-color-name></span></p><div class="td-swatches" role="radiogroup" aria-label="Kapak rengi"></div></div>
  <label class="td-upload"><strong>1. Görselini yükle</strong><span class="td-small">PNG, JPG veya WebP · En fazla 20 MB</span><input type="file" accept="image/png,image/jpeg,image/webp" data-file disabled></label>
  <fieldset class="td-controls" disabled><legend class="td-small">2. Yerleşimini ayarla</legend>
  <label>Boyut <output data-value="scale">100%</output><input data-control="scale" aria-label="Görsel boyutu" type="range" min="0.1" max="4" step="0.01" value="1"></label>
  <label>Sağa / sola <output data-value="x">0%</output><input data-control="x" aria-label="Yatay konum" type="range" min="-1" max="1" step="0.01" value="0"></label>
  <label>Yukarı / aşağı <output data-value="y">0%</output><input data-control="y" aria-label="Dikey konum" type="range" min="-1" max="1" step="0.01" value="0"></label>
  <button type="button" class="td-button td-secondary" data-reset>Yerleşimi sıfırla</button></fieldset>
  <canvas class="td-print" aria-label="Düz baskı alanı önizlemesi" hidden></canvas>
  <p class="td-warning" role="status"></p><p class="td-error" role="alert"></p>
  <div class="td-actions"><label class="td-small">Sipariş adedi <input type="number" data-quantity min="1" step="1" value="1" inputmode="numeric"></label><p class="td-small td-selection"></p><button type="button" class="td-button" data-buy disabled>Satın al</button><div class="td-original-step" hidden><h3>3. Orijinal baskı dosyanı yükle</h3><p class="td-small">Önizlemede kullandığın tasarımın yüksek çözünürlüklü orijinalini seç. Bu dosya önizlemeyi değiştirmez.</p><label class="td-upload">Orijinal dosya<input type="file" data-original accept=".png,.jpg,.jpeg,.webp,.pdf,.tif,.tiff,.ai,.eps"></label><p class="td-small" data-original-name role="status"></p><label class="td-small"><input type="checkbox" data-original-confirm> Dosyanın önizlemedeki tasarıma ait olduğunu onaylıyorum.</label><p class="td-small" data-purchase-note></p><button type="button" class="td-button" data-add disabled>Sepete ekle ve devam et</button><button type="button" class="td-button td-secondary" data-back>Tasarıma dön</button></div>
  <a class="td-small td-cart-link" hidden>Sepeti kontrol et</a><p class="td-small">Orijinal görsel, önizleme ve baskı yerleşimi siparişinize eklenir.</p></div></div></div>`;

const COLOR_NAMES = {
  'siyah': '#1d1d1f', 'beyaz': '#f4f4f2', 'gri': '#8a8d8f', 'açık gri': '#c4c6c7', 'koyu gri': '#4f5254', 'füme': '#4a4d50', 'antrasit': '#383b3e',
  'kırmızı': '#c0262d', 'bordo': '#6d1a24', 'mavi': '#2563b8', 'lacivert': '#1f2d4d', 'açık mavi': '#8ec3e6', 'bebek mavisi': '#a9cfe8', 'turkuaz': '#1aa6a6',
  'yeşil': '#2f7d4f', 'koyu yeşil': '#1f4d36', 'açık yeşil': '#8cc49a', 'mint': '#9fd8c3', 'haki': '#6b6b47', 'zeytin': '#6b6b3a', 'sarı': '#f2c230',
  'hardal': '#c99a2e', 'turuncu': '#e8772e', 'pembe': '#e98fb0', 'pudra': '#e3b7b0', 'fuşya': '#c2287a', 'mor': '#6b3fa0', 'lila': '#b89ad6',
  'kahverengi': '#6b4630', 'kahve': '#6b4630', 'bej': '#d8c6a5', 'krem': '#efe6d2', 'gümüş': '#c0c3c6', 'altın': '#c9a24a', 'bakır': '#b87333'
};
function colorFromName(name) {
  const key = String(name || '').toLocaleLowerCase('tr').trim();
  if (COLOR_NAMES[key]) return COLOR_NAMES[key];
  const match = Object.keys(COLOR_NAMES).sort((a, b) => b.length - a.length).find(k => key.includes(k));
  if (match) return COLOR_NAMES[match];
  return window.CSS?.supports?.('color', key) ? key : '#5a5d60';
}
const COLOR_OPTION = /renk|color|colour/i;

function disposeScene(scene) {
  const materials = new Set(), textures = new Set(), geometries = new Set();
  scene?.traverse(node => {
    if (node.geometry) geometries.add(node.geometry);
    for (const material of [].concat(node.material || [])) {
      materials.add(material);
      for (const value of Object.values(material)) if (value?.isTexture) textures.add(value);
    }
  });
  textures.forEach(t => t.dispose()); materials.forEach(m => m.dispose()); geometries.forEach(g => g.dispose());
}
function blobFromCanvas(canvas) {
  return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Görsel oluşturulamadı.')), 'image/png'));
}

export class TermosDesigner extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.generation = 0;
    this.dialog = document.createElement('dialog');
    this.dialog.className = 'td-dialog';
    this.dialog.setAttribute('role', 'dialog');
    this.dialog.setAttribute('aria-modal', 'true');
    this.dialog.setAttribute('aria-label', 'Termosunu tasarla');
    this.dialog.innerHTML = dialogMarkup;
    this.append(this.dialog);
    this.$ = selector => this.dialog.querySelector(selector);
    this.querySelector('[data-open]').addEventListener('click', () => this.open());
    this.$('[data-close]').addEventListener('click', () => this.close());
    this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.close(); });
    this.dialog.addEventListener('keydown', e => this.trapFocus(e));
    this.$('[data-file]').addEventListener('change', e => this.loadImage(e.target.files[0]));
    this.$('[data-reset]').addEventListener('click', () => { this.resetPlacement(); this.draw(); });
    this.$('[data-add]').addEventListener('click', () => this.addToCart());
    this.$('[data-buy]').addEventListener('click', () => this.beginPurchase());
    this.$('[data-back]').addEventListener('click', () => { this.$('.td-original-step').hidden = true; this.$('[data-buy]').hidden = false; this.$('[data-buy]').focus(); });
    this.$('[data-original]').addEventListener('change', e => this.setOriginal(e.target.files[0]));
    this.$('[data-original-confirm]').addEventListener('change', () => this.showSelection());
    this.$('[data-quantity]').addEventListener('input', () => this.showSelection());
    this.dialog.querySelectorAll('[data-control]').forEach(input => input.addEventListener('input', () => {
      this.position[input.dataset.control] = Number(input.value);
      this.draw();
    }));
    this.variantHandler = () => { if (this.dialog.open && this.product) this.showSelection(); };
    for (const name of ['variant:change', 'variant:changed', 'product:variant-change', 'change']) document.addEventListener(name, this.variantHandler);
  }
  disconnectedCallback() {
    this.busy = false; this.close();
    for (const name of ['variant:change', 'variant:changed', 'product:variant-change', 'change']) document.removeEventListener(name, this.variantHandler);
    this.dialog?.remove(); this.initialized = false;
  }
  trapFocus(event) {
    if (event.key !== 'Tab') return;
    const controls = [...this.dialog.querySelectorAll('button, input, a[href]')].filter(el => !el.matches(':disabled') && el.getClientRects().length);
    const first = controls[0], last = controls.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  }
  resetPlacement() {
    this.position = { scale: 1, x: 0, y: 0 };
    this.dialog.querySelectorAll('[data-control]').forEach(input => { input.value = this.position[input.dataset.control]; });
  }
  async open() {
    if (this.dialog.open) return;
    const generation = ++this.generation;
    this.previousFocus = document.activeElement;
    this.previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.dialog.showModal();
    this.$('[data-close]').focus();
    this.resetPlacement();
    this.minimumQuantity = Math.max(1, Math.trunc(Number(this.dataset.minQuantity) || 1));
    this.$('[data-quantity]').min = this.minimumQuantity;
    this.$('[data-quantity]').value = this.minimumQuantity;
    this.$('.td-loading').hidden = false;
    this.$('.td-error').textContent = '';
    this.$('.td-warning').textContent = '';
    this.$('[data-file]').value = '';
    this.resetOriginal();
    this.$('.td-original-step').hidden = true;
    this.$('[data-buy]').hidden = false;
    this.$('.td-print').hidden = true;
    this.$('.td-product').textContent = this.dataset.productTitle || 'Termos';
    this.$('.td-cart-link').href = this.dataset.cartUrl || '/cart';
    this.$('.td-cart-link').hidden = !this.submissionLocked;
    const width = Number(this.dataset.width), height = Number(this.dataset.height);
    this.dimensions = width > 0 && height > 0 ? { width, height } : null;
    const pw = Number(this.dataset.pixelWidth) || 2000, ph = Number(this.dataset.pixelHeight) || 1470;
    this.ratio = this.dimensions ? width / height : pw / ph;
    this.$('.td-measures').textContent = this.dimensions ? `Baskı alanı: ${width} × ${height} cm` : `Önerilen görsel: ${pw} × ${ph} piksel`;
    try {
      const [modules, product] = await Promise.all([loadThree(), this.getProduct()]);
      if (generation !== this.generation) return;
      this.product = product;
      this.$('[data-quantity]').value = Math.max(this.minimumQuantity, this.selection(true).quantity);
      await this.createScene(modules, generation);
      if (generation !== this.generation) return;
      this.$('[data-file]').disabled = false;
      this.renderColors();
      this.showSelection();
    } catch (error) {
      if (generation === this.generation) { this.release(); this.$('.td-error').textContent = error.message || '3D model yüklenemedi. Kapatıp tekrar deneyin.'; }
    } finally {
      if (generation === this.generation) this.$('.td-loading').hidden = true;
    }
  }
  async getProduct() {
    if (this.dataset.demo === 'true') return { variants: [] };
    const response = await fetch(`${this.dataset.productUrl}.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Ürün bilgisi alınamadı. Sayfayı yenileyin.');
    return response.json();
  }
  async createScene([THREE, { GLTFLoader }, { OrbitControls }, { RoomEnvironment }], generation) {
    this.THREE = THREE;
    const stage = this.$('.td-stage');
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
    this.renderer = renderer;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    stage.replaceChildren(renderer.domElement);
    const scene = this.scene = new THREE.Scene();
    const camera = this.camera = new THREE.PerspectiveCamera(35, 1, 0.01, 100);
    const environment = new RoomEnvironment();
    const pmrem = new THREE.PMREMGenerator(renderer);
    this.environment = pmrem.fromScene(environment, 0.04);
    scene.environment = this.environment.texture;
    environment.dispose(); pmrem.dispose();
    scene.add(new THREE.HemisphereLight(0xffffff, 0x999999, 1));
    const light = new THREE.DirectionalLight(0xffffff, 2); light.position.set(2, 4, 3); scene.add(light);
    const gltf = await new GLTFLoader().loadAsync(this.dataset.model);
    if (generation !== this.generation) { disposeScene(gltf.scene); return; }
    const model = gltf.scene;
    scene.add(model);
    const box = new THREE.Box3().setFromObject(model), size = box.getSize(new THREE.Vector3());
    const extent = Math.max(size.x, size.y, size.z);
    if (!Number.isFinite(extent) || extent <= 0) throw new Error('3D modelin boyutları geçersiz.');
    model.scale.multiplyScalar(2 / extent);
    box.setFromObject(model);
    model.position.sub(box.getCenter(new THREE.Vector3()));
    const print = this.printCanvas = document.createElement('canvas');
    const targetWidth = this.dimensions ? Math.round(this.dimensions.width / 2.54 * 300) : Number(this.dataset.pixelWidth) || 2000;
    const targetHeight = this.dimensions ? Math.round(this.dimensions.height / 2.54 * 300) : Number(this.dataset.pixelHeight) || 1470;
    const cap = Math.min(1, 8192 / targetWidth, 8192 / targetHeight, Math.sqrt(16000000 / (targetWidth * targetHeight)));
    print.width = Math.max(1, Math.round(targetWidth * cap)); print.height = Math.max(1, Math.round(targetHeight * cap));
    this.texture = new THREE.CanvasTexture(print);
    this.texture.colorSpace = THREE.SRGBColorSpace; this.texture.flipY = false;
    this.texture.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
    let found = false;
    this.originalMaterials = new Set();
    const matteCache = new Map(), lids = [], others = [];
    model.traverse(node => {
      if (!node.isMesh) return;
      const replace = material => {
        const name = material.name.toUpperCase();
        if (name === (this.dataset.material || 'GOVDERESIM').toUpperCase()) {
          found = true; this.originalMaterials.add(material);
          return new THREE.MeshPhysicalMaterial({ map: this.texture, color: '#ffffff', metalness: 0.1, roughness: 0.5, envMapIntensity: 0.8 });
        }
        if (name === 'CELIK') {
          this.originalMaterials.add(material);
          return new THREE.MeshPhysicalMaterial({ color: '#dadde0', metalness: 1, roughness: 0.18, envMapIntensity: 1.6, clearcoat: 0.35, clearcoatRoughness: 0.1 });
        }
        // Kapak ve diğer parçalar mat görünür; renk seçimi yalnızca bunları boyar.
        if (matteCache.has(material)) return matteCache.get(material);
        this.originalMaterials.add(material);
        const matte = new THREE.MeshStandardMaterial({ color: material.color ? material.color.clone() : new THREE.Color('#2b2b2b'), map: material.map || null, normalMap: material.normalMap || null, roughness: 0.92, metalness: 0, envMapIntensity: 0.45 });
        matte.name = material.name;
        matteCache.set(material, matte);
        (/KAPAK|LID|CAP/i.test(name) ? lids : others).push(matte);
        return matte;
      };
      node.material = Array.isArray(node.material) ? node.material.map(replace) : replace(node.material);
    });
    this.lidMaterials = lids.length ? lids : others;
    if (!found) { console.warn('Termos: Baskı materyali bulunamadı:', this.dataset.material); throw new Error('Bu ürün için baskı alanı tanımlı değil.'); }
    camera.position.set(0, 0.35, 4.6);
    const controls = this.controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true; controls.enablePan = false;
    controls.minDistance = 2.7; controls.maxDistance = 7;
    controls.minPolarAngle = Math.PI * 0.2; controls.maxPolarAngle = Math.PI * 0.8;
    controls.autoRotate = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    controls.autoRotateSpeed = 0.7;
    controls.addEventListener('start', () => { controls.autoRotate = false; });
    this.resizeObserver = new ResizeObserver(() => {
      const { width, height } = stage.getBoundingClientRect();
      camera.aspect = Math.max(width, 1) / Math.max(height, 1); camera.updateProjectionMatrix();
      renderer.setSize(Math.max(width, 1), Math.max(height, 1), false);
    });
    this.resizeObserver.observe(stage);
    this.draw();
    renderer.setAnimationLoop(() => { controls.update(); renderer.render(scene, camera); });
  }
  async loadImage(file) {
    if (!file || this.busy) return;
    const generation = this.generation, imageGeneration = this.imageGeneration = (this.imageGeneration || 0) + 1;
    this.$('.td-error').textContent = '';
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 20 * 1024 * 1024) {
      this.$('.td-error').textContent = 'PNG, JPG veya WebP seçin. Dosya en fazla 20 MB olabilir.'; return;
    }
    this.$('[data-add]').disabled = true;
    let url;
    try {
      url = URL.createObjectURL(file);
      const image = new Image(); image.src = url; await image.decode();
      if (generation !== this.generation || imageGeneration !== this.imageGeneration) return;
      if (image.naturalWidth * image.naturalHeight > 64000000) throw new Error('Görsel çok büyük. En fazla 64 megapiksel bir görsel seçin.');
      this.image = image; this.previewFile = file; this.resetOriginal();
      this.controls.autoRotate = false;
      this.resetPlacement(); this.draw();
      this.$('.td-controls').disabled = false; this.$('.td-print').hidden = false;
    } catch (error) { if (generation === this.generation) this.$('.td-error').textContent = error.message || 'Görsel okunamadı.'; }
    finally { if (url) URL.revokeObjectURL(url); if (generation === this.generation) this.showSelection(); }
  }
  draw() {
    if (!this.printCanvas) return;
    const canvas = this.printCanvas, ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
    if (this.image) {
      const { scale, x, y } = this.position;
      const p = placement(this.image.naturalWidth, this.image.naturalHeight, canvas.width, canvas.height, scale, x, y);
      ctx.drawImage(this.image, p.left, p.top, p.width, p.height);
      this.imageVisible = p.left < canvas.width && p.top < canvas.height && p.left + p.width > 0 && p.top + p.height > 0;
      let warning = '';
      if (this.dimensions) {
        const dpi = this.image.naturalWidth / (p.width / canvas.width * this.dimensions.width / 2.54);
        if (dpi < 150) warning = `Baskı kalitesi düşük olabilir (yaklaşık ${Math.round(dpi)} DPI).`;
      } else if (this.image.naturalWidth < p.width || this.image.naturalHeight < p.height) warning = 'Baskı kalitesi düşük olabilir. Daha büyük bir görsel yükleyebilirsiniz.';
      if (!this.imageVisible) warning = 'Görsel baskı alanının dışında. Konumunu değiştirin.';
      this.$('.td-warning').textContent = warning;
    }
    for (const [key, value] of Object.entries(this.position)) this.$(`[data-value="${key}"]`).textContent = `${Math.round(value * 100)}%`;
    const preview = this.$('.td-print'); preview.width = 400; preview.height = Math.round(400 / this.ratio);
    preview.getContext('2d').drawImage(canvas, 0, 0, preview.width, preview.height);
    this.texture.needsUpdate = true;
    if (this.product) this.showSelection();
  }
  selection(fromProductForm = false) {
    const variants = this.product?.variants || [];
    const ids = new Set(variants.map(v => String(v.id)));
    const forms = [...document.querySelectorAll('main form[action*="/cart/add"], #MainContent form[action*="/cart/add"]')];
    const form = forms.find(f => ids.has(f.querySelector('[name="id"]')?.value) && !f.closest('dialog, product-card, quick-add-component') && f.getClientRects().length);
    const input = form?.querySelector('[name="id"]');
    const id = this.selectedVariantId || input?.value || new URL(location.href).searchParams.get('variant') || this.dataset.variantId;
    const variant = variants.find(v => String(v.id) === String(id));
    const quantityInput = form ? [...form.elements].find(el => el.name === 'quantity') : null;
    const quantity = Number(!fromProductForm && this.dialog.open ? this.$('[data-quantity]').value : quantityInput?.value || variant?.quantity_rule?.min || 1);
    return { variant, quantity, pending: Boolean(input?.disabled) };
  }
  renderColors() {
    const box = this.$('.td-colors'), list = this.$('.td-swatches');
    list.replaceChildren();
    let swatches = {};
    try { swatches = JSON.parse(this.dataset.swatches || '{}'); } catch { swatches = {}; }
    const options = this.product?.options || [];
    const index = options.findIndex(option => COLOR_OPTION.test(option?.name || option));
    const variants = this.product?.variants || [];
    const values = index < 0 ? [] : (options[index].values || [...new Set(variants.map(v => v.options[index]))]);
    box.hidden = !values.length;
    if (!values.length) return;
    const current = variants.find(v => String(v.id) === String(this.selection(true).variant?.id));
    let chosen = null;
    values.forEach(name => {
      const matches = variants.filter(v => v.options[index] === name);
      const available = matches.some(v => v.available);
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'td-swatch'; button.setAttribute('role', 'radio');
      button.style.setProperty('--td-swatch', swatches[name] || colorFromName(name));
      button.title = available ? name : `${name} · Stokta yok`;
      button.setAttribute('aria-label', button.title);
      button.disabled = !available;
      button.addEventListener('click', () => this.pickColor(name, index, button));
      list.append(button);
      if (available && (!chosen || current?.options[index] === name)) chosen = [name, button];
    });
    if (chosen) this.pickColor(chosen[0], index, chosen[1]);
    else this.$('[data-color-name]').textContent = 'Stokta yok';
  }
  pickColor(name, index, button) {
    const variants = this.product?.variants || [];
    const current = variants.find(v => String(v.id) === String(this.selectedVariantId)) || variants[0];
    const variant = variants.find(v => v.available && v.options[index] === name && v.options.every((o, i) => i === index || o === current?.options[i]))
      || variants.find(v => v.available && v.options[index] === name);
    if (!variant) return;
    this.selectedVariantId = variant.id; this.selectedColor = name;
    this.$('[data-color-name]').textContent = name;
    this.$('.td-swatches').querySelectorAll('.td-swatch').forEach(b => b.setAttribute('aria-checked', String(b === button)));
    const hex = (() => { try { return JSON.parse(this.dataset.swatches || '{}')[name]; } catch { return null; } })() || colorFromName(name);
    this.lidMaterials?.forEach(material => { material.map = null; material.color.set(hex); material.needsUpdate = true; });
    this.showSelection();
  }
  resetOriginal() {
    this.originalFile = null;
    this.$('[data-original]').value = '';
    this.$('[data-original-confirm]').checked = false;
    this.$('[data-original-name]').textContent = '';
  }
  setOriginal(file) {
    if (this.busy) return;
    this.resetOriginal();
    this.$('.td-error').textContent = '';
    if (file) {
      if (!/\.(png|jpe?g|webp|pdf|tiff?|ai|eps)$/i.test(file.name) || !file.size || file.size > 20 * 1024 * 1024) {
        this.$('.td-error').textContent = 'PNG, JPG, WebP, PDF, TIFF, AI veya EPS seçin. Dosya en fazla 20 MB olabilir.';
      } else {
        this.originalFile = file;
        this.$('[data-original-name]').textContent = file.name;
      }
    }
    this.showSelection();
  }
  beginPurchase() {
    if (this.busy || !this.image || !this.imageVisible) return;
    this.$('.td-original-step').hidden = false;
    this.$('[data-buy]').hidden = true;
    this.showSelection();
    this.$('[data-original]').focus();
  }
  showSelection() {
    const { variant, quantity, pending } = this.selection();
    const label = variant?.public_title || variant?.title || '';
    this.$('.td-selection').textContent = variant ? `${label === 'Default Title' ? '' : label + ' · '}${quantity} adet · Minimum ${this.minimumQuantity} adet${variant.available ? '' : ' · Stokta yok'}` : 'Minimum ' + this.minimumQuantity + ' adet';
    const ready = !this.busy && !this.submissionLocked && !pending && this.image && this.imageVisible && Number.isInteger(quantity) && quantity >= this.minimumQuantity;
    const priced = Number(variant?.price) > 0;
    this.$('[data-buy]').disabled = !ready;
    this.$('[data-purchase-note]').textContent = !priced ? 'Bu ürünün fiyatı henüz belirlenmedi. Tasarımını deneyebilirsin; satın alma fiyat açıklandığında açılacak.' : !variant?.available ? 'Bu ürün şu anda satışa uygun değil.' : 'Orijinal dosyan, tasarım önizlemen ve baskı yerleşimin siparişine eklenecek.';
    this.$('[data-add]').disabled = !ready || !variant?.available || !priced || !this.originalFile || !this.$('[data-original-confirm]').checked;
    this.$('[data-original]').disabled = this.busy;
    this.$('[data-original-confirm]').disabled = this.busy;
    this.$('[data-back]').disabled = this.busy;
  }
  async addToCart() {
    if (this.busy || this.submissionLocked || !this.image || !this.imageVisible || !this.originalFile || !this.$('[data-original-confirm]').checked) return;
    const { variant, quantity, pending } = this.selection();
    if (pending || !variant?.available || !(Number(variant.price) > 0) || !Number.isInteger(quantity) || quantity < this.minimumQuantity) {
      this.$('.td-error').textContent = `Stokta olan bir varyant seçin. Minimum sipariş ${this.minimumQuantity} adettir.`; return;
    }
    this.busy = true; this.showSelection(); this.$('[data-add]').textContent = 'Sepete ekleniyor…';
    this.$('[data-quantity]').disabled = true;
    this.$('[data-file]').disabled = true; this.$('.td-controls').disabled = true; this.$('[data-close]').disabled = true;
    this.$('.td-error').textContent = '';
    let dispatched = false, accepted = false;
    try {
      this.renderer.render(this.scene, this.camera);
      const [preview, print] = await Promise.all([blobFromCanvas(this.renderer.domElement), blobFromCanvas(this.printCanvas)]);
      const fd = new FormData();
      fd.append('id', variant.id); fd.append('quantity', quantity);
      fd.append('properties[Baskı Dosyası]', this.originalFile);
      fd.append('properties[Önizleme]', preview, 'onizleme.png');
      fd.append('properties[Baskı Hazır]', print, 'baski-hazir.png');
      const { scale, x, y } = this.position;
      fd.append('properties[Baskı Ayarı]', JSON.stringify({ surum: 1, olcek: scale, x, y, konum_birimi: 'baski_alani_orani', zemin: 'beyaz', yerlestirme: 'contain', piksel: [this.printCanvas.width, this.printCanvas.height], cm: this.dimensions ? [this.dimensions.width, this.dimensions.height] : null }));
      fd.append('properties[_Tasarım Kimliği]', crypto.randomUUID());
      dispatched = true;
      const response = await fetch(this.dataset.addUrl || '/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status >= 400) { dispatched = false; throw new Error(result.description || result.message || 'Ürün sepete eklenemedi.'); }
      accepted = true;
      const item = result.items?.[0] || result;
      const filesSaved = ['Baskı Dosyası', 'Önizleme', 'Baskı Hazır'].every(key => {
        const value = item.properties?.[key];
        return typeof value === 'string' && /^(https?:\/\/|\/)/.test(value) && !value.includes('[object');
      });
      if (!filesSaved) { this.submissionLocked = true; throw new Error('Ürün sepete eklendi ancak baskı dosyalarının kaydı doğrulanamadı. Ödeme yapmadan önce sepetten bu ürünü kaldırın ve mağazaya bildirin.'); }
      this.busy = false; this.close();
      this.querySelector('.td-result').textContent = 'Tasarımınız sepete eklendi.';
      if (this.dataset.redirect === 'true') { location.assign(this.dataset.cartUrl || '/cart'); return; }
      // Sepet yenileme hatası, başarılı eklemeyi yeniden denemeye dönüştürülmez.
      try { await this.refreshCart(); } catch (error) {
        console.warn('Termos: Sepet görünümü yenilenemedi.', error);
        const link = document.createElement('a'); link.href = this.dataset.cartUrl || '/cart'; link.textContent = ' Sepeti aç';
        this.querySelector('.td-result').append(link);
      }
    } catch (error) {
      if (dispatched && !accepted) this.submissionLocked = true;
      this.$('.td-error').textContent = this.submissionLocked && !accepted ? 'Bağlantı kesildi; ürün eklenmiş olabilir. Tekrar eklemeden önce sepeti kontrol edin.' : error.message;
      this.$('.td-cart-link').hidden = !this.submissionLocked;
    } finally {
      this.busy = false;
      this.$('[data-quantity]').disabled = false;
      this.$('[data-add]').textContent = 'Sepete ekle ve devam et'; this.$('[data-close]').disabled = false;
      this.$('[data-file]').disabled = !this.renderer; this.$('.td-controls').disabled = !this.image;
      this.showSelection();
    }
  }
  async refreshCart() {
    const response = await fetch(`${this.dataset.cartUrl || '/cart'}.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Sepet okunamadı.');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.hidden = cart.item_count === 0;
      const count = el.querySelector('[aria-hidden="true"]');
      if (count) count.textContent = cart.item_count;
      const accessible = el.querySelector('.visually-hidden'); if (accessible) accessible.textContent = `${cart.item_count} ürün`;
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    // Horizon'ın herkese açık yenileme metodu; bilinmeyen temalarda sepet bağlantısı kalır.
    const items = document.querySelector('cart-items-component');
    if (typeof items?.fetchCartData === 'function') await items.fetchCartData();
    const result = this.querySelector('.td-result');
    const link = document.createElement('a'); link.href = this.dataset.cartUrl || '/cart'; link.textContent = ' Sepeti aç'; result.append(link);
  }
  close() {
    if (this.busy) return;
    ++this.generation;
    if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.previousOverflow; this.previousFocus?.focus(); }
    this.release();
    if (this.$) { this.$('[data-file]').disabled = true; this.$('.td-controls').disabled = true; this.$('[data-add]').disabled = true; }
  }
  release() {
    this.resizeObserver?.disconnect(); this.controls?.dispose();
    this.renderer?.setAnimationLoop(null);
    disposeScene(this.scene);
    this.originalMaterials?.forEach(material => { Object.values(material).forEach(value => { if (value?.isTexture) value.dispose(); }); material.dispose(); });
    this.texture?.dispose(); this.environment?.dispose(); this.renderer?.dispose(); this.renderer?.forceContextLoss();
    this.$?.('.td-stage').replaceChildren();
    this.image = this.previewFile = this.originalFile = this.scene = this.renderer = this.texture = this.environment = this.controls = this.printCanvas = null;
    this.originalMaterials = this.lidMaterials = null;
    this.selectedVariantId = this.selectedColor = null;
  }
}
if (!customElements.get('termos-designer')) customElements.define('termos-designer', TermosDesigner);
